import { observer } from 'mobx-react-lite'
import { useCdtCodeMapping } from 'app/components/cdt-code-mapping/useCdtCodeMapping'
import { CdtCodeMappingShadcnComponent } from 'app/components/cdt-code-mapping/CdtCodeMappingShadcnComponent'

export default observer(function CdtCodes(): React.ReactElement {
  const hookData = useCdtCodeMapping()
  return <CdtCodeMappingShadcnComponent {...hookData} />
})
